module.exports = __webpack_public_path__ + "img/zhipinban3.33f345cc.jpg";